import axios from 'axios'
import toast from 'react-hot-toast'

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
})

api.interceptors.request.use(cfg => {
  const token = localStorage.getItem('pos_token')
  if (token) cfg.headers.Authorization = `Bearer ${token}`
  return cfg
})

api.interceptors.response.use(
  res => res,
  err => {
    const msg = err.response?.data?.error || 'Error de conexión'
    if (err.response?.status === 401) {
      localStorage.removeItem('pos_token')
      localStorage.removeItem('pos_usuario')
      window.location.href = '/login'
    } else if (err.response?.data?.error?.startsWith('SUSCRIPCION_SUSPENDIDA::')) {
      // Puede pasar en el login (lo maneja Login.jsx directo) o en CUALQUIER
      // otro momento si la suscripción vence mientras alguien ya está trabajando.
      // En ese segundo caso: cerramos la sesión y guardamos el aviso para que
      // Login.jsx lo muestre apenas cargue, sin que la persona tenga que
      // adivinar por qué de repente "dejó de funcionar" el sistema.
      const yaEstabaEnLogin = window.location.pathname === '/login'
      if (!yaEstabaEnLogin) {
        sessionStorage.setItem('pos_bloqueo_suscripcion', err.response.data.error)
        localStorage.removeItem('pos_token')
        localStorage.removeItem('pos_usuario')
        window.location.href = '/login'
      }
    } else {
      toast.error(msg)
    }
    return Promise.reject(err)
  }
)

export const authAPI = {
  login:   (data) => api.post('/auth/login', data),
  me:      ()     => api.get('/auth/me'),
  password:(data) => api.put('/auth/password', data),
}

export const productosAPI = {
  listar:      (params) => api.get('/productos', { params }),
  obtener:     (id)     => api.get(`/productos/${id}`),
  crear:       (data)   => api.post('/productos', data),
  actualizar:  (id, d)  => api.put(`/productos/${id}`, d),
  eliminar:    (id)     => api.delete(`/productos/${id}`),
  ajustarStock:(id, d)  => api.post(`/productos/${id}/ajuste-stock`, d),
  stockBajo:   ()       => api.get('/productos/alertas/stock-bajo'),
  importar:    (file)   => {
    const formData = new FormData()
    formData.append('archivo', file)
    return api.post('/productos/importar', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    })
  },
}

export const inventarioAPI = {
  resumenCategorias: ()       => api.get('/categorias/resumen'),
  crearCategoria:    (data)   => api.post('/categorias', data),
  editarCategoria:   (id, d)  => api.put(`/categorias/${id}`, d),
  recepcion:         (data)   => api.post('/inventario/recepcion', data),
}

export const cajaAPI = {
  turnoActivo:        ()     => api.get('/caja/turno-activo'),
  pendientes:         ()     => api.get('/caja/pendientes'),
  abrir:              (data) => api.post('/caja/abrir', data),
  cerrar:             (data) => api.post('/caja/cerrar', data),
  corregirCierre:     (id, data) => api.put(`/caja/cierre/${id}`, data),
  resumen:            (id)   => api.get(`/caja/resumen/${id}`),
  ultimoFondo:        ()     => api.get('/caja/ultimo-fondo'),
  registrarMovimiento:(data) => api.post('/caja/movimiento', data),
}

export const ventasAPI = {
  crear:   (data)     => api.post('/ventas', data),
  listar:  (params)   => api.get('/ventas', { params }),
  obtener: (id)       => api.get(`/ventas/${id}`),
  anular:  (id, data) => api.post(`/ventas/${id}/anular`, data),
}

export const reportesAPI = {
  ventasDia:            (params) => api.get('/reportes/ventas-dia', { params }),
  productosMasVendidos: (params) => api.get('/reportes/productos-mas-vendidos', { params }),
  ventasRango:          (params) => api.get('/reportes/ventas-rango', { params }),
  ventasPorVendedor:    (params) => api.get('/reportes/ventas-por-vendedor', { params }),
  arqueo:               (params) => api.get('/reportes/arqueo', { params }),
  buscarProducto:       (params) => api.get('/reportes/buscar-producto', { params }),
}

export const billingAPI = {
  listar:         ()      => api.get('/superadmin/suscripciones'),
  historial:      (meses) => api.get('/superadmin/suscripciones/historial-pagos', { params: { meses } }),
  actualizar:     (id, d) => api.put(`/superadmin/suscripciones/${id}`, d),
  suspender:      (id)    => api.post(`/superadmin/suscripciones/${id}/suspender`),
  reactivar:      (id, d) => api.post(`/superadmin/suscripciones/${id}/reactivar`, d),
  generarLink:    (id)    => api.post(`/pagos/generar-link/${id}`),
}

export const superadminAPI = {
  listarEmpresas: ()     => api.get('/superadmin/empresas'),
  obtenerEmpresa: (id)   => api.get(`/superadmin/empresas/${id}`),
  crearEmpresa:   (data) => api.post('/superadmin/empresas', data),
  editarEmpresa:  (id,d) => api.put(`/superadmin/empresas/${id}`, d),
}

export const utilAPI = {
  mediosPago: () => api.get('/medios-pago'),
  categorias: () => api.get('/categorias'),
  sucursales: () => api.get('/sucursales'),
  cajas:      () => api.get('/cajas'),
}

export const fmt      = n => '$' + Math.round(n || 0).toLocaleString('es-CL')
export const fmtFecha = d => new Date(d).toLocaleDateString('es-CL')
export const fmtHora  = d => new Date(d).toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' })

export default api
